import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerCardInvoker, CustomerCardStoreService, ICustomerCardState } from 'src/app/shared/services/store/customer-card-store.service';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { Modal } from 'src/app/shared/modals/modal';
import { Subscription } from 'rxjs';
import { SelectedOrgService } from 'src/app/shared/services/selected-org.service';
import { TabViewModule } from 'primeng/tabview';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ModalHeaderComponent } from 'src/app/shared/modals/components/modal-header/modal-header.component';
import { SkeletonModule } from 'primeng/skeleton';
import { CustomerCardCustomerComponent } from '../customer-card-modal/customer-card-customer/customer-card-customer.component';
import { CustomerCardAttendanceComponent } from '../customer-card-modal/customer-card-attendance/customer-card-attendance.component';
import { TranslateModule } from '@ngx-translate/core';
import { UserNameOrEmailPipe } from 'src/app/shared/pipes/user-name-or-email.pipe';

export enum LecturerCustomerCardTab {
  CUSTOMER = 'CUSTOMER',
  ATTENDANCE = 'ATTENDANCE',
}

@Component({
  selector: 'app-lecturer-customer-card-modal',
  standalone: true,
  imports: [
    CommonModule, TranslateModule,
    ProgressSpinnerModule, TabViewModule, SkeletonModule, UserNameOrEmailPipe,
    ModalHeaderComponent, CustomerCardCustomerComponent, CustomerCardAttendanceComponent,
  ],
  templateUrl: './lecturer-customer-card-modal.component.html',
  styleUrls: ['./lecturer-customer-card-modal.component.scss']
})
export class LecturerCustomerCardModalComponent extends Modal implements OnInit, OnDestroy {

  @Input() customerId: number | undefined;
  @Input() set activeTab(val: LecturerCustomerCardTab) {
    if (val === LecturerCustomerCardTab.CUSTOMER) this.activeTabIndex = 0;
    else if (val === LecturerCustomerCardTab.ATTENDANCE) this.activeTabIndex = 1;
  }

  activeTabIndex: number = 0;
  state: ICustomerCardState | undefined;
  orgId: number | null = null;

  subs: Subscription[] = [];

  constructor(
    private customerCardStore: CustomerCardStoreService,
    public selectedOrg: SelectedOrgService,
    private utilsService: UtilsService,
  ) {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.state = this.customerCardStore.state;
    this.init();

    
    
  }

  init() {
    this.orgId = this.selectedOrg.getCurrentValue();
    if (!this.customerId || !this.orgId) return;

    this.customerCardStore.init(this.customerId, this.orgId, CustomerCardInvoker.LECTURER);
  }

  onTabChange(index: any) {
    this.activeTabIndex = index;
  }


  override ngOnDestroy(): void {
    super.ngOnDestroy();
    
    this.subs.forEach((sub) => sub.unsubscribe());
  }
  
}
